import { fetchV3, fetchV3Payload } from "./client";
import { converterDataField } from "utils/common";
import { extractFileNameFromUrl } from "@/constants/index.js";
import { resolveDefaultAddressJson } from "schemas/address";

export const getAdminDoctor = (uuid) =>
  fetchV3({ url: `admin/doctors/${uuid}/`, useLoading: true });

export const mapAdminDoctor = (raw) => {
  const defaultAddress =
    resolveDefaultAddressJson(raw.user) ||
    (raw.info_address_line
      ? { formatted_address: raw.info_address_line }
      : null);
  const data = {
    ...converterDataField(raw, true),
    user: {
      ...converterDataField(raw.user, true),
      default_address: defaultAddress,
    },
  };

  data.uploadApplications = (data.uploadApplications || []).map((i) => {
    let convertedData = converterDataField(i, true);
    if (convertedData.extra != null) {
      convertedData.extra = {
        ...converterDataField(convertedData.extra, true),
        name: extractFileNameFromUrl(convertedData.extra.file),
      };
    }
    return {
      ...convertedData,
      name: extractFileNameFromUrl(convertedData.file),
    };
  });
  return data;
};

export const fetchAdminDoctor = async (uuid) => {
  const response = await getAdminDoctor(uuid);
  if (!response?.data) return null;
  return mapAdminDoctor(response.data);
};

export const createDoctor = (body) =>
  fetchV3(
    {
      method: "POST",
      url: "admin/doctors/create/",
      body,
      useLoading: true,
    },
    body instanceof FormData,
  );

export const updateDoctorRequest = (uuid, body, isAdmin) =>
  fetchV3(
    {
      method: "PUT",
      url: `${isAdmin ? "admin/" : ""}doctors/${uuid}/`,
      body,
      useLoading: true,
    },
    body instanceof FormData,
  );

export const uploadDoctorFile = (body) =>
  fetchV3(
    {
      method: "POST",
      url: "doctors/file/",
      body,
      useLoading: true,
    },
    true,
  );

export const deleteDoctorFile = (uuid) =>
  fetchV3({
    method: "DELETE",
    url: `doctors/file/${uuid}/`,
    useLoading: true,
  }).then(fetchV3Payload);

export const listDoctorForms = () =>
  fetchV3({
    url: "doctors/forms/",
    useLoading: true,
  }).then(fetchV3Payload);

export const getDoctorSignature = (doctorId) =>
  fetchV3({
    url: `doctors/${doctorId}/signature/`,
    method: "GET",
    useLoading: true,
  });

export const putDoctorSignature = (doctorId, file) =>
  fetchV3(
    {
      url: `doctors/${doctorId}/signature/`,
      method: "PUT",
      body: file,
      useLoading: true,
    },
    true,
  );

export const listDoctorArchivedDocuments = (doctorId) =>
  fetchV3({
    url: `admin/doctors/${doctorId}/archive/`,
    useLoading: true,
  });

export const mapArchivedDocuments = (items = []) =>
  items.map((i) => {
    const convertedData = converterDataField(i, true);
    return {
      ...convertedData,
      name: extractFileNameFromUrl(convertedData.file),
    };
  });

export const unarchiveDoctorDocument = (doctorId, fileId, force) =>
  fetchV3({
    url: `admin/doctors/${doctorId}/archive/${fileId}/`,
    method: "PUT",
    body: { force: !!force },
    useLoading: true,
  });

export const archiveDoctorDocumentRequest = (fileId) =>
  fetchV3({
    url: `doctors/file/${fileId}/`,
    method: "PATCH",
    body: { accepted_status: "archived" },
    useLoading: true,
  });
